import React from 'react';

import Alert from '@material-ui/lab/Alert';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Grid from '@material-ui/core/Grid';
import Link from '@material-ui/core/Link';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';
import { connect } from 'react-redux';
import Auth from 'auth/Auth';
import Icons from 'consts/icons';
import UserSessionDataHandler from 'auth/UserSessionsDataHandler';
import { addAlert } from 'store/actions/alert/alerts';
import { fromUnderScoreToUpperCase } from 'helpers/variablesNamesFit';
import { postRequest } from 'helpers/apiRequests';
import { useLoginStyles } from 'consts/styles/Login';

const auth = new Auth();

const SignIn = props => {
  const {
    history,
    language,
    siteLang,
    setSeeableLoader,
    dispatch,
    setType,
  } = props;
  const [values, setValues] = React.useState({
    username: '',
    password: '',
  });
  const [error, setError] = React.useState(false);

  const classes = useLoginStyles();

  const handleChange = event => {
    const { target } = event;
    const { name, value } = target;
    setValues({
      ...values,
      [name]: value,
    });
  };

  const handleResetPassword = () => {
    setType('reset');
  };
  const handleEnterClick = event => {
    if (event.key === 'Enter') {
      login();
    }
  };

  const login = () => {
    setSeeableLoader(true);
    setError(false);
    postRequest('login', {
      username: values.username,
      password: values.password,
    })
      .then(result => {
        if (result.status !== 200) {
          setValues({ username: '', password: '' });
          setSeeableLoader(false);
          setError(true);
          dispatch(
            addAlert({
              title: language.alerts.loginError.title_,
              desc: language.alerts.loginError.desc_,
              type: 'error',
            })
          );
          return;
        }

        setError(false);
        const parsedData = fromUnderScoreToUpperCase(result.data);
        const userSettingsData = parsedData.configuration;

        userSettingsData[UserSessionDataHandler.defaultLanguage] = siteLang;
        userSettingsData[UserSessionDataHandler.defaultTimezone] =
          siteLang === 'pl' ? 'Poland' : 'UTC';
        userSettingsData[UserSessionDataHandler.defaultBuffer] =
          parsedData.buffer || 0;

        UserSessionDataHandler.saveRefreshToken(parsedData.refresh);
        UserSessionDataHandler.saveJurisdiction(parsedData.jurisdiction[0]);
        UserSessionDataHandler.saveJurisdictionWithBuffer(
          parsedData.jurisdictionWithBuffer[0]
        );

        auth.authenticate(parsedData.access, userSettingsData, {
          username: parsedData.username,
          firstName: parsedData.firstName,
          lastName: parsedData.lastName,
          adminPermissions: parsedData.adminPermissions,
          group: parsedData.group,
          phone: parsedData.phone,
          email: parsedData.email,
          address: parsedData.address,
          uid: parsedData.uid,
          organization: parsedData.organization,
        });

        dispatch(
          addAlert({
            title: language.alerts.loginSuccess.title_,
            desc: language.alerts.loginSuccess.desc_,
            type: 'success',
          })
        );
        setSeeableLoader(false);
        history.push('/');
      })
      .catch(error => {
        setSeeableLoader(false);
        setError(true);
        dispatch(
          addAlert({
            title: language.alerts.loginError.title_,
            desc: error.message,
            type: 'error',
          })
        );
      });
  };

  return (
    <>
      <div className={`${classes.Login}__card__header`}>
        {language.loginScreen.helloMessage_}
      </div>
      <div className={`${classes.Login}__card__subheader`}>
        {language.loginScreen.message_}
      </div>
      <form className={`${classes.Login}__card__form`} noValidate>
        <TextField
          variant="outlined"
          margin="normal"
          required
          fullWidth
          id="username"
          label={language.loginScreen.username_}
          name="username"
          autoComplete="username"
          autoFocus
          onChange={handleChange}
          value={values.username}
        />
        <TextField
          variant="outlined"
          margin="normal"
          required
          fullWidth
          name="password"
          label={language.loginScreen.password_}
          type="password"
          id="password"
          autoComplete="current-password"
          onChange={handleChange}
          onKeyPress={handleEnterClick}
          value={values.password}
        />
        <FormControlLabel
          control={<Checkbox value="remember" />}
          label={language.loginScreen.rememberMe_}
          className={`${classes.Login}__card__remember`}
        />
        <Button
          type="button"
          fullWidth
          className={`${classes.Login}__card__submit`}
          onClick={login}
        >
          {language.loginScreen.button_}
        </Button>
        <Grid container className={`${classes.Login}__card__links`}>
          <Grid item xs>
            <Link variant="body2" onClick={handleResetPassword}>
              <Icons.Filters.ButtonPublic />
              &nbsp;&nbsp;{language.loginScreen.forgotPassword_}
            </Link>
          </Grid>
        </Grid>
        {error ? (
          <Alert
            severity="error"
            className={`${classes.Login}__message ${classes.Login}__message--border--error`}
          >
            {language.alerts.loginError.desc_}
          </Alert>
        ) : (
          <div
            className={`${classes.Login}__message ${classes.Login}__message--hidden`}
          >
            &nbsp;
          </div>
        )}
      </form>
    </>
  );
};

SignIn.propTypes = {
  dispatch: PropTypes.func.isRequired,
  history: PropTypes.object,
  language: PropTypes.object.isRequired,
  setSeeableLoader: PropTypes.func,
  setType: PropTypes.func,
  siteLang: PropTypes.string,
};

const mapStateToProps = state => ({
  language: state.language,
});

export default connect(mapStateToProps)(SignIn);
